function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Text } from 'native-base';
import React, { memo, useMemo } from 'react';
import Functions from '../../../../utils/Functions';
import { Linking } from 'react-native';
import { useOfferCardContext } from '../../../context';
const LinkText = _ref => {
  let {
    metadata: tempMetaData,
    content: tempContent,
    event: {
      action
    } = {
      action: 'TextLinkClicked'
    }
  } = _ref;
  const contents = useMemo(() => {
    if (!Functions.isEmpty(tempMetaData) && tempMetaData.values) {
      return Functions.textReplacer(tempContent, tempMetaData.values);
    }
    return [{
      content: tempContent,
      metadata: tempMetaData
    }];
  }, [tempMetaData, tempContent]);
  const {
    logUserEvent,
    cardType
  } = useOfferCardContext() || {
    cardType: ''
  };
  const {
    href,
    values,
    ...rest
  } = tempMetaData;
  return /*#__PURE__*/React.createElement(Text, null, contents.map(_ref2 => {
    let {
      content
    } = _ref2;
    return /*#__PURE__*/React.createElement(Text, _extends({
      fontSize: "16",
      color: 'primary.400',
      testID: `${cardType}${content}`,
      accessibilityLabel: content
    }, rest, {
      accessibilityRole: "text",
      textDecorationLine: 'underline',
      textDecorationColor: 'primary.400',
      onPress: () => {
        Linking.openURL(href);
        logUserEvent({
          action: action,
          type: cardType,
          description: `${action} - ${cardType}`
        });
      }
    }), content);
  }));
};
export default /*#__PURE__*/memo(LinkText);
//# sourceMappingURL=LinkText.js.map